<template>
  <div>
    <div class="modal-header">
      <button type="button" class="close" @click="hide()" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
      <h4 class="modal-title">Zamień produkt: {{ productToReplace.name }}</h4>
    </div>
    <div class="modal-body">
      <replace-search-product
          :food="food"
          :plan="plan"
          :day="day"
          :product-to-replace="productToReplace">

      </replace-search-product>
    </div>
    <div class="modal-footer">
      <slot name="prevModal"></slot>
    </div>
  </div>
</template>
<script>
import {mapMutations, mapState,} from 'vuex';

export default {
  data() {
    return {
      productToReplace: null,
      food: null,
      plan: null,
      day: null,
    };
  },
  computed: {
    ...mapState({
      modalData: state => state.modal.data,
    }),

  },
  methods: {
    ...mapMutations([
      'hideModal',
    ]),
    hide() {
      this.hideModal();
    },
  },
  watch: {
    modalData: {
      immediate: true,
      handler: function (data) {
        this.productToReplace = data.productToReplace;
        this.food = data.food;
        this.plan = data.plan;
        this.day = data.day;
      },
    },
  },
};
</script>
